import { useCallback, useEffect, useRef, useState } from 'react';
import { useIntersection } from 'react-use';

import { useAnimatedPath } from '@/hooks';
import styles from './BannerAnimationContent.module.scss';

interface BannerAnimationContentProps {
  color?: string;
}

export default function BannerAnimationContent({ color = 'var(--white)' }: BannerAnimationContentProps) {
  const ref = useRef<HTMLSpanElement | null>(null);
  const svgRef = useRef<SVGSVGElement>(null);
  const [enabled, setEnabled] = useState(false);
  const intersection = useIntersection(ref as never, {});
  const [pathExist, setPathExist] = useState(false);
  const animatedProps = useAnimatedPath({
    enabled,
  });

  const createSvgPath = useCallback(() => {
    if (ref?.current?.parentElement && svgRef?.current && animatedProps?.ref?.current) {
      const { width: viewBoxWidth } = ref.current.parentElement.getBoundingClientRect();
      svgRef.current.setAttribute('viewBox', `0 0 ${viewBoxWidth} 18`);

      const amplitude = 7;
      const frequency = 0.1;
      const numPoints = 200;
      const interval = viewBoxWidth / (numPoints - 1);

      let d = 'M0 9';

      for (let i = 1; i < numPoints; i++) {
        const x = i * interval;
        const y = 9 + amplitude * Math.sin(frequency * x);
        d += ` L${x} ${y}`;
      }

      animatedProps.ref?.current.setAttribute('d', d);
    }
  }, [animatedProps]);

  useEffect(() => {
    if (!pathExist) {
      createSvgPath();
      setPathExist(true);
    }

    if (!enabled && intersection?.isIntersecting) {
      setEnabled(true);
    }
  }, [intersection, enabled, createSvgPath, pathExist]);
  return (
    <span ref={ref}>
      <svg ref={svgRef} width="100%" height="18" viewBox="0 0 190 18" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.svg}>
        <path {...animatedProps} stroke={color} strokeWidth="3" />
      </svg>
    </span>
  );
}
